import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

const ActionCard = props => {
  const {
    className,
    contentClassName,
    photoClassName,
    hover,
    photoStretch,
    photo,
    url,
    children,
    ...opts
  } = props;

  const classes = cx(
    'actionCard',
    {
      'has-hoverEffect': hover,
    },
    className
  );

  const photoClasses = cx(
    'actionCard-photo',
    {
      'has-coverPhoto': photoStretch === 'cover',
      'has-containPhoto': photoStretch === 'contain',
    },
    photoClassName
  );

  const contentClasses = cx('actionCard-content', contentClassName);

  return (
    <a href={url} className={classes} {...opts}>
      {photo && (
        <div
          className={photoClasses}
          style={{ backgroundImage: `url(${photo})` }}
        />
      )}
      <div className={contentClasses}>{children}</div>
    </a>
  );
};

ActionCard.propTypes = {
  className: PropTypes.string,
  contentClassName: PropTypes.string,
  photoClassName: PropTypes.string,
  hover: PropTypes.bool,
  photoStretch: PropTypes.oneOf(['contain', 'cover']),
  photo: PropTypes.string,
  url: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default ActionCard;
